import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import miniSideLogo from 'src/assets/mini-side-logo.png'
import mcSideLogo from 'src/assets/mc/side-logo.png';
import { DokIcon } from 'src/components';
import { isMC,isMini } from 'src/utils/env';
import { getMenus } from '../../routes/router';
import * as styles from './index.less';

const { Sider } = Layout;
const { SubMenu, Item } = Menu;
const menus = getMenus();

const getIcon = (icon, bool) => {
  if (typeof icon === 'string' && icon.indexOf('http') === 0) {
    return <img src={icon} alt="icon" className={styles.icon} />;
  }
  if (typeof icon === 'string') {
    return <DokIcon type={bool ? `${icon}_on` : icon} />;
  }
  return icon;
};

class SiderMenu extends Component {
  async componentDidMount() {
    const {
      token,
      loading,
      history,
      dispatch,
      cacheMenus,
      persistMenus,
      location: { pathname },
      userInfo: { show_report_entrance },
    } = this.props;
    if (token && loading) {
      await dispatch({ type: 'app/syncAppData', payload: { refuseReport: 1 } });
    }
    if (show_report_entrance && !isMC()) {
      const res = await dispatch({ type: 'app/fetchReportList' });
      const ids = (res?.reports?.data || []).map((v) => v.id);

      const hasReport = (v) => {
        const id = Number(v.path.replace('/v2/statistics/', ''));
        return isNaN(id) || ids.includes(id);
      };
      if (!hasReport({ path: pathname })) {
        history.push('/v2/statistics');
      }
      dispatch({
        type: 'app/setState',
        payload: {
          cacheMenus: cacheMenus.filter(hasReport),
          persistMenus: persistMenus.filter(hasReport),
        },
      });
    }
  }
  render() {
    const {
      location: { pathname },
    } = this.props;
    return (
      <Sider
        theme="light"
        trigger={null}
        defaultCollapsed
        collapsedWidth="72"
        className={styles.sider}
      >
        <div className={styles['icon-logo']}>
          {isMC() ? <img src={mcSideLogo} alt="logo" /> : (
            isMini() ? <img src={miniSideLogo} alt="logo" className={styles['mini-icon-logo']} /> : <DokIcon type="logo" />
          )}
        </div>
        <Menu
          key="Menu"
          theme="light"
          mode="inline"
          onClick={this.onMenuItemClick}
          className={styles['sider-menu']}
          style={{ minHeight: menus.length * 80 }}
          selectedKeys={[pathname.includes('/v2/statistics/') ? '/v2/statistics' : pathname]}
        >
          {this.getNavMenuItems(menus)}
        </Menu>
      </Sider>
    );
  }
  getMenuItemName = (key = '') => {
    const { locale = {} } = this.props;

    return key
      .split(',')
      .map((k) => locale[k] || k)
      .join('');
  };
  getNavMenuItems = (menusData) => {
    const {
      userInfo: { plugins_info: plugins, role, show_report_entrance },
      configs,
    } = this.props;
    if (!menusData) {
      return null;
    }
    return menusData
      .filter((item) => {
        if (item.pluginId && plugins) {
          //增加菜单插件判断
          const plugin = plugins.find((v) => v.plugins_id === item.pluginId);
          if (!plugin || String(plugin.status) !== '1') {
            return false;
          }
        }
        if (item.path === '/v2/statistics' && !show_report_entrance) {
          return false;
        }
        if (item.authority && !item.authority.includes(role)) {
          return false;
        }
        if(item.name === 'import_pre_sell_doc' && Number(configs.import_client_pre_sell_doc) !== 1){
          return false
        }
        return item.name && !item.hideInMenu;
      })
      .map((item) => {
        const key = `${item.path || item.name}`;
        // if (item.pluginId === '215') {
        //   item.children = reportList.map((v) => ({
        //     name: v.name,
        //     path: `/v2/statistics/${v.key || v.id}`,
        //     authority: ['admin', 'manager'],
        //   }));
        //   if (!item.children.length) {
        //     return null;
        //   }
        // }
        const childPaths = item.children?.map((child) => child.path);
        if (childPaths && childPaths.length) {
          const {
            location: { pathname },
          } = this.props;

          return (
            <SubMenu
              key={key}
              title={
                item.icon ? (
                  <span>
                    {getIcon(item.icon, childPaths.includes(pathname))}
                    <span>{this.getMenuItemName(item.name)}</span>
                  </span>
                ) : (
                  this.getMenuItemName(item.name)
                )
              }
              className={item.className}
            >
              {this.getNavMenuItems(item.children)}
            </SubMenu>
          );
        }
        return (
          <Item key={key} data={item}>
            {this.getMenuItemPath(item)}
          </Item>
        );
      })
      .filter((item) => !!item);
  };
  // 判断是否是http链接 返回 Link 或 a
  getMenuItemPath = (item) => {
    const {
      location: { pathname },
    } = this.props;
    const itemPath = this.conversionPath(item.path);
    // console.log(itemPath, pathname);
    const icon = getIcon(item.icon, itemPath === pathname);
    const { target, name } = item;
    if (/^https?:\/\//.test(itemPath)) {
      return (
        <a href={itemPath} target={target}>
          {icon}
          <span>{this.getMenuItemName(name)}</span>
        </a>
      );
    }
    return !item.path ? (
      <div target={target}>
        {icon}
        <span>{this.getMenuItemName(name)}</span>
      </div>
    ) : (
      <Link to={itemPath} target={target} replace={itemPath === this.props.location.pathname}>
        {icon}
        <span>{this.getMenuItemName(name)}</span>
      </Link>
    );
  };
  // 转化路径
  conversionPath = (path) => {
    if (path && path.indexOf('http') === 0) {
      return path;
    } else {
      return `/${path || ''}`.replace(/\/+/g, '/');
    }
  };
  // 点击侧边栏时添加顶部 tab
  onMenuItemClick = ({ item }) => {
    const { onMenuItemClick, dispatch } = this.props;
    const {
      data,
      data: { meta, hideTab },
    } = item.props;

    if (meta) dispatch(meta);
    if (!hideTab && onMenuItemClick) onMenuItemClick(data);
  };
}

export default connect(({ appState }) => ({
  token: appState.token,
  loading: appState.loading,
  userInfo: appState.userInfo,
  reportList: appState.reportList,
  cacheMenus: appState.cacheMenus,
  persistMenus: appState.persistMenus,
  configs: appState.configs
}))(SiderMenu);
